/** @type {Styles} */
export const styles = {
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'wrap',
  },
  linkInputForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  buttonSelectContainer: {
    marginLeft: {
      sm: 2,
    },
    flex: {
      sm: 1,
    },
    flexGrow: {
      xs: 1,
    },
    display: {
      xs: 'flex',
      sm: 'block',
    },
    mt: {
      xs: 1,
      sm: 0,
    },
    maxWidth: {
      xs: '100%',
      sm: 160,
    },
  },
  textFieldWrapper: {
    height: { xs: 128 },

    overflowY: 'scroll',
    padding: 2,
    border: 1,
    borderColor: 'gray.12',
    borderRadius: 1,
    flexGrow: 1,
    color: 'gray.80',
  },
  toolbarDivider: {
    borderColor: 'gray.12',
    '&.MuiDivider-middle': {
      paddingY: {
        xs: 0.25,
        sm: 1.2,
      },
      marginX: {
        xs: 0.75,
        sm: 1,
      },
    },
    height: {
      xs: 20,
      sm: 'auto',
    },
  },
  toolbar: {
    flexDirection: 'row',
    paddingY: 0.5,
    paddingX: 1,
    border: 1,
    borderRadius: 1,
    borderColor: 'gray.8',
    alignItems: 'center',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.04)',

    '::-webkit-scrollbar': {
      width: 0,
      height: 0,
      background: 'transparent',
    },
    overflow: 'scroll',
  },
  toolbarButton: {
    color: 'gray.56',
    border: 0,
    ':hover': {
      backgroundColor: 'transparent',
    },
    paddingY: 0,
    paddingX: {
      xs: 0,
      sm: 0.2,
    },
  },
  popoverHeader: {
    color: 'gray.80',
  },
  editorTypography: {
    marginY: 1.75,
    display: 'block',
  },
  linkPopper: {
    backgroundColor: 'gray.0',
    border: 1,
    borderColor: 'gray.12',
    borderRadius: 1,
    padding: 1,
  },
  linkInputPopover: {
    '& .MuiPaper-root': {
      width: { xs: '100%', sm: 266 },
      maxWidth: { xs: '100%', sm: 266 },

      backgroundColor: 'gray.0',
    },
  },
  mobileLinkInputPopover: {
    '& .MuiPaper-root': {
      left: { xs: '0 !important' },
    },
  },
  linkInputWrapper: {
    marginBottom: 2.5,
  },
  textEditorContainer: {
    display: 'flex',
    flexGrow: 1,
  },
  mobileLinkDialog: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    margin: '0 auto',
    maxHeight: '60vh',
    borderRadius: '12px 12px 0 0',
    zIndex: 99999,
    backgroundColor: 'gray.0',
    width: '100%',
  },
}
